import { MRT_SortingState } from "material-react-table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { SORT_ASC, SORT_DESC, SORT_PARAM_KEY, SORT_SPLIT_CHAR } from "src/_Globals/urls";

export const GRID_EMPTY_SORT: MRT_SortingState = [];

const mrtSortingToUrl = (sorting: MRT_SortingState): string => {
    return sorting.map((sort) => `${sort.id}:${sort.desc ? SORT_DESC : SORT_ASC}`).join(",");
};

export const urlToMrtSorting = (sortString: string): MRT_SortingState => {
    if (!sortString.trim()) return [];

    return sortString
        .split(",")
        .filter((sort) => sort.includes(SORT_SPLIT_CHAR))
        .map((sort) => {
            const [id, direction] = sort.split(SORT_SPLIT_CHAR);
            return { id: id.trim(), desc: direction.trim() === SORT_DESC };
        })
        .filter((sort) => sort.id);
};

export type GridSort = {
    sorting: MRT_SortingState;
    setSorting: Dispatch<SetStateAction<MRT_SortingState>>;
};

export const useGridSortUrlSync = (): GridSort => {
    const [searchParams, setSearchParams] = useSearchParams();
    const sortingSearchParam = searchParams.get(SORT_PARAM_KEY);

    const initialSort = sortingSearchParam === null ? GRID_EMPTY_SORT : urlToMrtSorting(sortingSearchParam);

    const [sorting, setSorting] = useState<MRT_SortingState>(initialSort);

    useEffect(() => {
        const newSearchParams = new URLSearchParams(searchParams);

        const sortingAsString = mrtSortingToUrl(sorting);
        if (sortingAsString !== "") {
            newSearchParams.set(SORT_PARAM_KEY, sortingAsString);
        } else {
            newSearchParams.delete(SORT_PARAM_KEY);
        }

        if (newSearchParams.toString() === searchParams.toString()) return;

        setSearchParams(newSearchParams);
    }, [sorting]);

    return { sorting, setSorting };
};
